<template>
  <b-card style="padding:40px;">
    <h5><b>DELIVERY ORDER (PREVIEW)</b></h5>
    <hr />
    <b-row>
      <b-col md="6">
        <b-form-group>
          <label :for="`input-name`">Full Name</label>
          <b-form-input
            v-model="form.name"
            :id="`input-name`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label :for="`input-date`">Date</label>
          <b-form-input
            v-model="form.date"
            :id="`input-date`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="6">
        <b-form-group>
          <label :for="`input-companyName`">Company Name</label>
          <b-form-input
            v-model="form.company"
            :id="`input-companyName`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label :for="`input-roles`">Roles</label>
          <b-form-input
            v-model="form.role"
            :id="`input-roles`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <TableDeliveryOrderPreview :fields="fields" :items="items" />
    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="sm" @click="onClickBack">
          BACK </b-button
        >&nbsp;&nbsp;&nbsp;
        <b-button variant="primary" size="sm" @click="onClickSubmit"
          >SUBMIT</b-button
        >
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import TableDeliveryOrderPreview from "@/table/user/deliveryOrder/TableDeliveryOrderPreview";
import moment from "moment";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import Failed from "@/pages/Notifications/Failed";

export default {
  data() {
    return {
      category: "",
      id: "",
      proCat: "",
      items: [],
      form: {
        id: "",
        category: "",
        name: "",
        role: "",
        company: "",
        date: "",
        type: ""
      },

      temp_data: "",

      fields: [
        {
          label: "No",
          key: "index",
          sortable: false
        },
        {
          label: "Product Name",
          key: "name",
          sortable: true
        },
        {
          label: "Quantity",
          key: "quantity",
          sortable: true
        },
        {
          label: "Quantity Type",
          key: "qtyType",
          sortable: true
        }
      ]
    };
  },
  created() {
    // let temp = localStorage.getItem("data_do");

    // let data = JSON.parse(temp);
    // localStorage.removeItem("data_do");

    // this.temp_data = data;

    // this.items = data.items;
    // this.id = data.id;
    // this.form.date = data.date ? moment(data.date).format("DD/MM/YYYY") : '';
    this.showDO();
  },
  methods: {
    showDO() {
      this.$store.dispatch("showDO", this.$route.query.id).then(res => {
        this.items = [];
        if (res.data.response.code === 100) {
          this.form.id = this.$route.query.id;
          this.form.purchase_id = res.data.data.purchase_id;
          this.form.name = res.data.data.userdetails.name;
          this.form.date = moment(res.data.data.date).format("DD/MM/YYYY");
          this.form.company = res.data.data.userdetails.company;
          this.form.role = res.data.data.userdetails.role_details.desc;
          res.data.data.pro_stock.forEach(element => {
            this.items.push({
              pro_stock_id: element.pro_stock_id,
              name: element.product.name,
              sku: element.product_id,
              quantity: element.quantity,
              qtyType: element.quantity_type === 1 ? "Pcs" : "Ctn"
            });
          });
        }
      });
    },
    onClickBack() {
      this.$router.push({
        path: `createdo?id=${this.form.id}&cat=4&type=update&from=update`
      });
    },
    onClickSubmit() {
      this.$store
        .dispatch("updateStatusMF", {
          category: 4,
          id: this.form.id
        })
        .then(res => {
          if (res.data.response.code === 1) {
            this.$notify({
              component: NotificationTemplate,
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success"
            });
            this.$router.push({
              path: `viewDOUser?id=${this.form.id}&cat=4&from=created`
            });
          } else {
            this.$notify({
              component: Failed,
              icon: "ti-close",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger"
            });
          }
        });
    }
  },
  components: {
    TableDeliveryOrderPreview
  }
};
</script>
<style lang="css" scoped></style>
